export var ModalTypes = {
  WITHDRAW: 'withdraw',
  WITHDRAW_ACCOUNT_VERIFICATION: 'withdrawAccountVerification',
  REVERSAL_WITHDRAW: 'reversalWithdraw',
  GAMBLING_CONTROLS: 'gamblingControls',
  POKER_BALANCE_TRANSFER: 'pokerBalanceTransfer'
};